import React, { useState } from 'react'


import HR1 from '../assets/Events/HR Conclave/IMG_7460.gif';
import HR2 from '../assets/Events/HR Conclave/IMG_7463.gif';
import HR3 from '../assets/Events/HR Conclave/IMG_7467.gif';
import HR4 from '../assets/Events/HR Conclave/IMG_7547.gif';
import HR5 from '../assets/Events/HR Conclave/IMG_7557.gif';
import HR6 from '../assets/Events/HR Conclave/IMG_7559.gif';
import HR7 from '../assets/Events/HR Conclave/IMG_7564.gif';

import NEP1 from '../assets/Events/nep/DSC_2588.gif';
import NEP2 from '../assets/Events/nep/DSC_2591.gif';
import NEP3 from '../assets/Events/nep/DSC_2597.gif';
import NEP4 from '../assets/Events/nep/DSC_2604.gif';
import NEP5 from '../assets/Events/nep/DSC_2605.gif';
import NEP6 from '../assets/Events/nep/DSC_2619.gif';
import NEP7 from '../assets/Events/nep/DSC_2624.gif';
import NEP8 from '../assets/Events/nep/DSC_2639.gif';


import JB7 from '../assets/Events/jubin visit/IMG_3082.gif';
import JB8 from '../assets/Events/jubin visit/IMG_4541.gif';


import KVM1 from '../assets/Events/KVM 2024/DSC00350.gif';
import KVM2 from '../assets/Events/KVM 2024/DSC00353.gif';
import KVM3 from '../assets/Events/KVM 2024/DSC00413.gif';
import KVM4 from '../assets/Events/KVM 2024/DSC00447.gif';
import KVM5 from '../assets/Events/KVM 2024/DSC00464.gif';
import KVM6 from '../assets/Events/KVM 2024/DSC00600.gif';
import KVM7 from '../assets/Events/KVM 2024/DSC00614.gif';
import KVM8 from '../assets/Events/KVM 2024/DSC00622.gif';
import KVM9 from '../assets/Events/KVM 2024/DSC00733.gif';
import KVM10 from '../assets/Events/KVM 2024/DSC00736.gif';
import KVM11 from '../assets/Events/KVM 2024/DSC00742.gif';
import KVM12 from '../assets/Events/KVM 2024/IMG_0976.gif';
import KVM13 from '../assets/Events/KVM 2024/IMG_0986.gif';
import KVM14 from '../assets/Events/KVM 2024/IMG_1087.gif';

import SS1 from '../assets/Events/sichak samman/DSC01089.gif';
import SS2 from '../assets/Events/sichak samman/IMG_1137.gif';
import SS3 from '../assets/Events/sichak samman/IMG_1166.gif';
import SS4 from '../assets/Events/sichak samman/IMG_1279.gif';
import SS5 from '../assets/Events/sichak samman/IMG_1343.gif';


import EventImg1 from "../assets/images/event1.jpeg";
import EventImg2 from "../assets/images/event2.jpeg";
import EventImg3 from "../assets/images/event3.jpeg";
import Footer from '../components/Footer';
import EventGalleryModal from './EventGalleryModal';



const events = [
    {
        id: 1,
        title: 'HR Conclave 2.0',
        image: HR1,
        date: 'October 26, 2024',
        gallery: [HR1, HR2, HR3, HR4, HR5, HR6, HR7]
    },
    {
        id: 2,
        title: 'National Conference on NEP',
        image: NEP1,
        date: 'October 5, 2024',
        gallery: [NEP1, NEP2, NEP3, NEP4, NEP5, NEP6, NEP7, NEP8]
    },
    {
        id: 3,
        title: "Celibrity Visit: Jubin Nautiyal's University Visit",
        image: JB7,
        date: 'November 9, 2024',
        gallery: [JB7, JB8]
    },
    {
        id: 4,
        title: 'Krishi Vigyan Mela ',
        image: KVM1,
        date: 'December 10 & 11, 2024',
        gallery: [KVM1, KVM2, KVM3, KVM4, KVM5, KVM6, KVM7, KVM8, KVM9, KVM10, KVM11, KVM12, KVM13, KVM14]
    },
    {
        id: 5,
        title: 'Shikshak Samman',
        image: SS1,
        date: 'November 9, 2024',
        gallery: [SS1, SS2, SS3, SS4, SS5]
    }
]

const EventsPage = () => {
    const [selectedEvent, setSelectedEvent] = useState(null);

    const openEventGallery = (event) => {
        setSelectedEvent(event);
    };

    const closeEventGallery = () => {
        setSelectedEvent(null);
    };

    return (
        <div>
            <div className="w-full relative bg-gradient-to-b from-white to-gray-50 ml-3 mr-3">
                <div className='w-full min-h-screen bg-gray-100 py-8 md:py-12 font-opensans mt-[100px] mb-[300px]'>
                    <div className='mx-auto px-4 sm:px-6 lg:px-8'>
                        {/* Title */}
                        <h1 className='text-[#0e4d38] text-center font-bold text-3xl md:text-4xl uppercase mb-8 md:mb-10'>
                            Events
                        </h1>

                        {/* Events Grid */}
                        <div className='grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8'>
                            {events.map((event) => (
                                <div
                                    key={event.id}
                                    className='bg-white rounded-lg shadow-md hover:shadow-xl overflow-hidden transform transition-transform duration-300 hover:scale-105'
                                >
                                    {/* Image Section */}
                                    <div className='h-48 sm:h-56 md:h-64 overflow-hidden'>
                                        <img
                                            src={event.image}
                                            alt={event.title}
                                            className='w-full h-full object-cover'
                                        />
                                    </div>

                                    {/* Details Section */}
                                    <div className='p-4 md:p-6'>
                                        <h2 className='text-xl md:text-2xl font-semibold text-[#0e4d38] mb-2 md:mb-3'>
                                            {event.title}
                                        </h2>
                                        <span className='block text-yellow-600 font-medium mb-4'>
                                            {event.date}
                                        </span>
                                        <div className='flex justify-end'>
                                            <button
                                                onClick={() => openEventGallery(event)}
                                                className='bg-gradient-to-br from-yellow-200 via-yellow-300 to-amber-300 px-3 py-2 rounded-full text-black text-sm md:text-base hover:bg-yellow-400 transition duration-300'
                                            >
                                                View Gallery
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>

                    {/* Gallery Modal */}
                    {selectedEvent && (
                        <EventGalleryModal
                            event={selectedEvent}
                            onClose={closeEventGallery}
                        />
                    )}
                </div>

            </div>

            <Footer />
        </div>

    )
}

export default EventsPage;
